








































import { query } from 'express';
import { Vue, Component, Prop } from 'vue-property-decorator';
import StudentRegisterButton from './StudentRegisterButton.vue';

@Component({
  components: {
    StudentRegisterButton,
  },
})
export default class StudentMailRegisterPage extends Vue {
  mail = '';
  password = '';
  building_id = '';
  isShowPass = false;
  public title = 'メール登録';

  viewPassword() {
    this.isShowPass = true;
  }
  created() {
    this.building_id = (this.$route.query.building as string) || 'co01';
  }
}
